import { useQuery } from '@tanstack/react-query';

import { useParams } from 'react-router-dom';
import { getApiV1AnalogueModelsByIdComputeCases } from '../api/generated';
import { useAccessToken } from '../auth/AccessTokenContext';
import { queryKeys } from './queryKeys';

export const useFetchCases = (options?: { poll?: boolean }) => {
  const { modelId } = useParams();
  const token = useAccessToken();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.modelCases(modelId as string),
    queryFn: () =>
      getApiV1AnalogueModelsByIdComputeCases({
        path: { id: modelId as string },
      }),
    select: (res) => res.data?.data ?? [],
    enabled: !!token && !!modelId,
    refetchOnMount: 'always',
    refetchInterval: options?.poll
      ? (query) => {
          const cases = query.state.data?.data?.data ?? [];
          const hasRunning = cases.some(
            (c: { jobStatus?: string }) =>
              c.jobStatus === 'Running' || c.jobStatus === 'Waiting',
          );
          return hasRunning ? 30000 : false;
        }
      : false,
  });

  return query;
};
